import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import LoginMobileHeader from '../components/header/LoginMobileHeader';
import InstituteMobileHeader from '../components/header/InstituteMobileHeader';
import CRMobileHeader from '../components/header/CRMobileHeader';
import MobileHeader from '../components/header/MobileHeader';
import LoginHeader from '../components/header/LoginHeader';
import InstituteHeader from '../components/header/InstituteHeader';
import CRHeader from '../components/header/CRHeader';
import NonLoginHeader from '../components/header/NonLoginHeader';
import Review from '../components/aboutPage/Review';
import BannerCounter from '../components/aboutPage/BannerCounter';
import Iconbox3 from '../components/aboutPage/Iconbox3';
import Testimonial from '../components/aboutPage/Testimonial';
import Footer from '../components/footer';
import Gotop from '../components/gotop';

import { Link } from "react-router-dom";
import img1 from "../assets/images/job/work-icon-1.jpg";
import img2 from "../assets/images/job/work-icon-2.jpg";
import img3 from "../assets/images/job/work-icon-3.jpg";

const Vision = () => {
	const [isShowMobile, setShowMobile] = useState(false);
	const handleMobile = () => {
		const getMobile = document.querySelector(".menu-mobile-popup");
		setShowMobile(!isShowMobile);
		!isShowMobile
			? getMobile.classList.add("modal-menu--open")
			: getMobile.classList.remove("modal-menu--open");
	};
	const module = localStorage.getItem('Module')

	return (
		<>
			<Helmet>
				<title>Vision | Jobkikhoj</title>
				<meta name="description" content=" " />
				<meta name="keywords" content=" " />
				<meta property="og:title" content="Vision | Jobkikhoj " />
				<meta property="og:description" content="" />
				<meta property="og:url" content="https://jobkikhoj.com" />
			</Helmet>
			{module === 'Candidate' ? <LoginMobileHeader handleMobile={handleMobile} /> :
				module === 'Institution' ? <InstituteMobileHeader handleMobile={handleMobile} /> :
					module === 'Company' ? <CRMobileHeader handleMobile={handleMobile} /> :
						module === 'Recruiter' ? <CRMobileHeader handleMobile={handleMobile} /> :
							<MobileHeader handleMobile={handleMobile} />}
			{module === 'Candidate' ? <LoginHeader handleMobile={handleMobile} /> :
				module === 'Institution' ? <InstituteHeader handleMobile={handleMobile} /> :
					module === 'Company' ? <CRHeader handleMobile={handleMobile} /> :
						module === 'Recruiter' ? <CRHeader handleMobile={handleMobile} /> :
							<NonLoginHeader handleMobile={handleMobile} />}

			<div className="pt-70">
				<Review />
				<BannerCounter />
				<section className="wd-iconbox style-3 inner-iconbox-section p-0">
					<div className="container">
						<div className="title-iconbox style-3 stc">
							<h4>How it work?</h4>
							{/* <p>
								Pellentesque quis lectus sagittis, gravida erat id, placerat
								tellus.
							</p> */}
						</div>
						<div className="row All-CICR-Class">
							<div className="col-lg-12">
								{/* <div className="group-col-3"> */}





								{/* </div> */}
							</div>

							<div className="tf-iconbox style-3 cl3 stc2 p-2 col-md-6 custom-works-card  text-center">
								<div className="box-header">
									<div className="img1">
										<img src={img1} alt="img" className="mb-1" />
									</div>
								</div>
								<div className="box-content">
									<h6 className="box-title">
										<Link to="/Blogsingle_v1">Candidates</Link>
									</h6>
									<h6 className="f-700 mb-4">Find Your Dream Job - Start your Career Journey Today</h6>
									<ul>
										<li>Build a winning profile that attracts top recruiters.</li>
										<li>Explore curated job listings tailored to your skills.</li>
										<li>Ace assessments and track your applications effortlessly.</li>
									</ul>
									{/* <button>
										Start Now&nbsp;
										<span className="icon-arrow-right2" />
									</button> */}
								</div>
							</div>

							<div className="tf-iconbox style-3 cl3 stc2 col-md-6 custom-works-card  text-center">
								<div className="box-header">
									<div className="img1">
										<img src={img2} alt="img" className="mb-1" />
									</div>
								</div>
								<div className="box-content">
									<h6 className="box-title">
										<Link to="/Blogsingle_v1">Recruiters</Link>
									</h6>
									<h6 className="f-700 mb-4">🤝 Hire the Best Talent - Find the Right Talent in Just a click</h6>

									<ul>
										<li>Post jobs, shortlist candidates, and streamline interviews.</li>
										<li>Evaluate talent with AI-proctored assessments.</li>
										<li>Boost your hiring efficiency with real-time updates.</li>
									</ul>
									{/* <button>
										Start Now&nbsp;
										<span className="icon-arrow-right2" />
									</button> */}
								</div>
							</div>

							<div className="tf-iconbox style-3 cl3 stc2 col-md-6 custom-works-card text-center">
								<div className="box-header">
									<div className="img1">
										<img src={img3} alt="img" className="mb-1" />
									</div>
								</div>
								<div className="box-content ">
									<h6 className="box-title">
										<Link to="/Blogsingle_v1">
											Companies
										</Link>
									</h6>
									<h6 className="f-700 mb-4">📈 Streamline Your Recruitment - Achieve Hiring Excellence</h6>

									<ul>
										<li >Manage recruitments with a simple, intuitive interface.</li>
										<li>Collaborate with recruiters for seamless hiring.</li>
										<li>Track job postings and candidates all in one place</li>
									</ul>
									{/* <button>
										Start Now&nbsp;
										<span className="icon-arrow-right2" />
									</button> */}
								</div>
							</div>

							<div className="tf-iconbox style-3 cl3 stc2 col-md-6 custom-works-card text-center">
								<div className="box-header">
									<div className="img1">
										<img src={img3} alt="img" className="mb-1" />
									</div>
								</div>
								<div className="box-content ">
									<h6 className="box-title">
										<Link to="/Blogsingle_v1">
											Institutions
										</Link>
									</h6>
									<h6 className="f-700 mb-4">🎓 Empower Student Success - Shape careers with confidence</h6>
									<ul>
										<li >Showcase your students to top recruiters.</li>
										<li>Track placement progress and success stories.</li>
										<li>Stay ahead with analytics and trends.</li>
									</ul>
									{/* <button>
										Start Now&nbsp;
										<span className="icon-arrow-right2" />
									</button> */}
								</div>
							</div>
						</div>
					</div>
				</section>
				<Iconbox3 />

				<section className="wd-banner-CTA">
					<div className="container">
						<div className="row">
							<div className="col-lg-12  wow fadeInUp">
								<div className="group-banner-CTA">
									<h3>Job Opportunities Are Always Open</h3>
									{/* <p>
										Aenean porta, eros lacus congue lorem, sit amet mollis magna
										velit ac erat.
									</p> */}
									<div className="group-btn">

										<button to="/Jobs" className="tf-btn">Search Job</button>
										<button className="tf-btn">Find Candidates</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
				<Footer />
				<Gotop />
			</div>
		</>
	)
}

export default Vision